import React from 'react'
import cn from 'classnames'

import './styles.scss'

export const Paper = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={cn('paper', className)} {...props} />
)
